type MsgHandler<Ctx> = (data: any, ctx: Ctx) => void;
type ProducerFn<Ctx> = (ctx: Ctx) => Promise<void>;

export class Router<Ctx = any> {
    private _handlers = new Map<string, MsgHandler<Ctx>>();
    private _producers: ProducerFn<Ctx>[] = [];

    on(type: string, handler: MsgHandler<Ctx>): this {
        this._handlers.set(type, handler);
        return this;
    }

    producer(fn: ProducerFn<Ctx>): this {
        this._producers.push(fn);
        return this;
    }

    include(other: Router<any>): this {
        other._handlers.forEach((handler, type) => {
            this._handlers.set(type, handler);
        });
        for (const producer of other._producers) {
            this._producers.push(producer);
        }
        return this;
    }

    dispatch(data: any, ctx: Ctx): void {
        this._handlers.get(data.type)?.(data, ctx);
    }

    get producers(): ProducerFn<Ctx>[] {
        return this._producers;
    }
}
